// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
import { ContainerControl } from './ContainerControl';
import { ControlsTypes } from '../UtilsClasses/FactoryConstants';
export class DynPropertyControl extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.DynPropertyControl;
    }
    oninit() {
        super.oninit();
        this.observe('name', this.onNameChanged);
        this.observe('dp.localizationKey', this.localize);
        this.observe('dp.customCSS', this.onCustomCSSChanged, { init: false });
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        const locKey = this.get('dp.localizationKey');
        void this.set('label', Resources.getResource(locKey));
    }
    onCustomCSSChanged() {
        const style = this.get('dp.customCSS');
        if (style !== undefined) {
            void this.set('additionalClassName', style);
        }
    }
    onNameChanged() { }
}
ContainerControl.extendWith(DynPropertyControl, {
    data: function () {
        return {
            label: '',
            dp: null,
            SLNumericLink: null,
            TPNumericLink: null,
            PriceNumericLink: null,
            StopPriceNumericLink: null
        };
    }
});
